declare global {
  interface RouterMeta {
    title: string;
  }
  interface Router {
    path: string;
    name: string;
    icon?: string;
    permission?: string;
    meta?: RouterMeta;
    component: any;
    children?: Array<Router>;
  }
  interface System {
    import(request: string): Promise<any>;
  }
  var System: System;
}
import login from '../views/login.vue';
import main from '../views/main.vue';
import flightReservationMonitor from '../views/pages/flight/flightReservationMonitor.vue';

export const loginRouter: Router = {
  path: '/',
  name: 'login',
  meta: {
    title: 'LogIn',
  },
  component: () => import('../views/login.vue'),
};

export const otherRouters: Router = {
  path: '/main',
  name: 'main',
  permission: '',
  meta: { title: 'ManageMenu' },
  component: main,
  children: [],
};

export const appRouters: Array<Router> = [
  {
    path: '/pages/flight',
    name: 'flight',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: '&#xe68a;',
    component: main,
    children: [
      {
        path: 'flightReservationMonitor',
        meta: { title: 'Flight Reservation Monitor' },
        name: 'flightReservationMonitor',
        component: () =>
          import('../views/pages/flight/flightReservationMonitor.vue'),
      },
    ],
  },
];

export const routers = [loginRouter, ...appRouters, otherRouters];
